import Flex from 'components/Flex'
import { StyledTabs } from 'components/TabsPaneStyles'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const CardRow = styled(Flex)`
  gap: 25px;
`
export const StyledTab = styled(StyledTabs)`
  .ant-tabs-content {
    height: 250px !important;
    overflow: scroll;
    &::-webkit-scrollbar {
      display: '';
    }
  }
`
export const TabFlex = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_90};
`
export const DriveTableDiv = styled.div`
  margin: 15px 0 0 0;
  padding: 1px 0px;
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
`
